module.exports = __webpack_public_path__ + "img/gold_card.99498452.png";